import { ENDPOINT } from '../globals/endpoint';
import { getReCaptchaToken } from './recaptcha-helper';
import { getAuthorizationTokenFromLS } from './authtoken-helper';
import { StatusCodeError } from '../utils/status-range-error';
import { RecaptchaError } from '../utils/recaptcha-error';
import { WidgetTranslations } from '../globals/translations';

declare global {
  interface Window {
    ProgConnect: { apiBaseUrl: string; recapSiteKey: string; authToken: string; translations?: Partial<WidgetTranslations>; launchFunction; threatMetrixSessionId: string };
  }
}

export const apiDateFormatter = (date: string): string => {
  const [month, day, year] = date.split('/');

  return `${year}-${month}-${day}`;
};

export const getReCaptchaAction = (endpoint: ENDPOINT): string => {
  switch (endpoint) {
    case ENDPOINT.Authorize:
      return 'Authorize';
    case ENDPOINT.Checkout:
      return 'Checkout';
    case ENDPOINT.LeaseAppUpdate:
      return 'LeaseAppUpdate';
    case ENDPOINT.LeaseAppSubmit:
      return 'LeaseAppSubmit';
    case ENDPOINT.Sign:
      return 'Sign';
    case ENDPOINT.CreditCard:
      return 'CreditCard';
    case ENDPOINT.SignChangeCard:
      return 'SignChangeCard';
    case ENDPOINT.FindApproval:
      return 'FindLeaseApp';
    case ENDPOINT.Cart:
      return 'SubmitCart';
    case ENDPOINT.VerifyOtp:
      return 'FindVerify';
    case ENDPOINT.ResendOtp:
      return 'FindResend';
    default:
      return 'homepage';
  }
};

export const apiHelper = async (endpoint: ENDPOINT, init?: RequestInit): Promise<Response> => {
  const url = `${window.ProgConnect.apiBaseUrl}${endpoint}`;
  let recaptchaToken;

  try {
    recaptchaToken = await getReCaptchaToken(getReCaptchaAction(endpoint));
  } catch (error) {
    throw new RecaptchaError();
  }
  const authToken = await getAuthorizationTokenFromLS();

  const headers = {
    ...init.headers,
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-PL-Token': recaptchaToken,
    ...(typeof authToken !== 'undefined' && { Authorization: `ProgConnect ${authToken}` }),
  };

  const response = await fetch(url, { ...init, credentials: 'include', headers });

  if (!response.ok) {
    throw new StatusCodeError(response);
  }

  return response;
};
